import { updateCatalogItemStatus } from './catalog-button.js';
import {visibilityCartWidget, getСartTotal} from './cart-widget.js';
import { showOrederBlockMessage, showOrederBlockLink } from './order-block.js';

const carts = document.querySelectorAll('.cart');

function updateTotalPrice(items) {
  const totalPrice = items.reduce((sum, item) => sum + (Number(item.price) || 0), 0).toFixed(2).replace(/\.00$/, '');

  carts.forEach((cartElement) => {
    const totalPriceContainer = cartElement.querySelector('.cart__total-price');
    totalPriceContainer.innerHTML = totalPrice > 0 ? `<span>Итого: <span>${totalPrice} &#8381;</span></span>` : '';
  });
}

function deleteItem(cart, itemId) {
  const index = cart.findIndex((item) => item.id === itemId);
  if (index === -1) return;

  cart.splice(index, 1);
  localStorage.setItem('sd-catalog-cart', JSON.stringify(cart));

  updateCatalogItemStatus(cart);
  getСartTotal(cart);
  renderCart(cart);

  console.log(cart);
}

function createCartItemElement(item, cartItems) {
  const cartItemElement = document.createElement('div');
  cartItemElement.classList.add('cart__item');
  cartItemElement.textContent = item.title;
  cartItemElement.dataset.id = item.id;

  const itemPrice = document.createElement('span');
  itemPrice.innerHTML = `${item.price} &#8381;`;
  cartItemElement.append(itemPrice);

  const deleteButton = document.createElement('button');
  deleteButton.classList.add('cart__delete');
  deleteButton.innerHTML = '<span class="visually-hidden">Удалить</span>';
  deleteButton.addEventListener('click', () => deleteItem(cartItems, item.id));
  cartItemElement.append(deleteButton);

  return cartItemElement;
}

const renderCartMessage = (items) => {
  const cartMessageContainer = document.querySelectorAll('.cart__message');

  if (items.length > 0) {
    cartMessageContainer.forEach((e) => {
      e.textContent = '';
    });
  } else {
    cartMessageContainer.forEach((e) => {
      e.textContent = 'Корзина пуста';;
    });
  }
};

function renderCart(items) {
  carts.forEach((cartElement) => {
    const cartItemsContainer = cartElement.querySelector('.cart__items');
      cartItemsContainer.innerHTML = '';

      items.forEach((item) => {
        cartItemsContainer.append(createCartItemElement(item, items));
      });
    });

  renderCartMessage(items);
  showOrederBlockMessage(items);
  showOrederBlockLink(items);
  updateTotalPrice(items);
  getСartTotal(items);
  visibilityCartWidget(items);
}

export {
  renderCart,
  getСartTotal,
  renderCartMessage
};